export function clampSamplingRate(samplingRate) {
    return Math.min(1, Math.max(0, samplingRate));
}
